import utils from '../utils';

const fillerWords = 'the to in from a is on of in that with at as'.split(/\s+/);
let dicts = {
	'en-us': {
		apply: 'Apply',
		search: 'search',
		searching: 'searching',
		apierror:
			'CDC Search is undergoing routine maintenance and will be restored shortly.<br />We apologize for the inconvenience and invite you to return later or go to our <a href="//www.cdc.gov/diseasesconditions/">A-Z index</a> to browse by topic.',
		advancedSearch: 'Advanced Search',
		page: 'Page',
		next: 'Next',
		nextPage: 'Next Page',
		first: 'First',
		filter: 'Filter',
		firstPage: 'First Page',
		previousPage: 'Previous Page',
		cdcRecommendations: 'Recommended by CDC',
		previous: 'Previous',
		searchResults: 'Search Results',
		of: 'of',
		related: 'Related',
		resultsFor: '$1 returned for',
		returnedFor: '$1 returned for',
		pageReturnedFor: 'Page $1 of $2 $3 returned for',
		searchInstead: 'Search instead for',
		noResultsMessage: 'No results',
		noResults: 'No $1 found for',
		zeroResults: 'No $1 found.',
		zeroSuggestion: 'Consider adjusting your search terms.',
		noSearchMessage: 'Use the search above or browse our A-Z Index to find what you are looking for:',
		seeResultsFor: 'Did you want to see results for',
		localSearchPre: 'We are <b>only</b> including results from the',
		localSearchPost: 'site',
		localSearchAllPre: 'Do you want to see results',
		localSearchAllPost: 'from all sites',
		zeroDidyoumean: 'Also try',
		filterResults: 'Filter Results',
		clear: 'clear',
		clearAll: 'Clear All',
		clearFilter: 'Clear Filters',
		formAll: 'All these words',
		formAny: 'Any of these words',
		formExact: 'This exact word or phrase',
		formNone: 'None of these words',
		all: 'Must include',
		any: 'Include any',
		exact: 'Matching',
		none: 'Not including',
		language: 'Language',
		anyLanguage: 'Any Language',
		url: 'URL contains',
		dates: 'Between dates',
		anyDate: 'any',
		topic: 'Topics',
		audience: 'Audiences',
		contenttype: 'Content Types',
		popularTerms: 'People also search...',
		langen: 'English',
		langes: 'Spanish',
		langfr: 'French',
		langde: 'German',
		langzh: 'Chinese',
		langko: 'Korean',
		langvi: 'Vietnamese',
		langja: 'Japanese',
		langru: 'Russian',
		langpt: 'Portuguese',
		langit: 'Italian',
		resultType: 'results',
		resultTypepage: 'web pages',
		resultTypedoc: 'documents',
		viewInPage: 'View in Page',
		dateRange: 'Date Range',
		allDates: 'All Dates',
		last7Days: 'Last 7 Days',
		last30Days: 'Last 30 Days',
		last60Days: 'Last 60 Days',
		last90Days: 'Last 90 Days',
		filterByDate: 'Filter by date',
	},
	'es-us': {
		apply: 'Aplicar',
		search: 'buscar',
		searching: 'buscando',
		apierror:
			'CDC Search is undergoing routine maintenance and will be restored shortly.<br />We apologize for the inconvenience and invite you to return later or go to our <a href="//www.cdc.gov/diseasesconditions/">A-Z index</a> to browse by topic.',
		advancedSearch: 'Búsqueda Avanzada',
		cdcRecommendations: 'Recomendaci&oacute;n de CDC',
		page: 'P&aacute;gina',
		next: 'Siguiente',
		nextPage: 'P&aacute;gina Siguiente',
		first: 'Primera',
		firstPage: 'Primera P&aacute;gina',
		previous: 'Anterior',
		previousPage: 'P&aacute;gina Anterior',
		searchResults: 'Resultados de la búsqueda',
		of: 'de',
		resultsFor: 'Resultados encontrados para',
		returnedFor: 'Resultados encontrados para',
		pageReturnedFor: 'Página $1 de resultados encontrados para',
		noResultsMessage: 'No hay resultados',
		noResults: 'No se encontraron resultados para',
		zeroResults: 'No se encontraron resultados.',
		zeroSuggestion: 'Considere revisar sus términos de búsqueda.',
		noSearchMessage: 'Utilice la búsqueda superior o explore nuestro índice A-Z para encontrar lo que busca:',
		localSearchPre: 'Incluimos resultados de b&uacute;squeda de',
		localSearchPost: '',
		localSearchAllPre: '&iquest;Desea ver los resultados',
		localSearchAllPost: 'de todos los sitios',
		zeroDidyoumean: 'Intenta también',
		filterResults: 'Filtrar Resultados',
		filter: 'Filtrar',
		clear: 'borrar',
		clearAll: 'Borrar Todo',
		clearFilter: 'Borrar Filtros',
		formAll: 'Todas estas palabras',
		formAny: 'Cualquiera de estas palabras',
		formExact: 'Esta frase o palabra exacta',
		formNone: 'Ninguna de estas palabras',
		all: 'deban incluir',
		any: 'incluyan',
		exact: 'coincidan exactamente con',
		none: 'que no incluyan',
		language: 'idioma',
		anyLanguage: 'Cualquier idioma',
		url: 'URL incluir',
		dates: 'Entre estas fechas',
		anyDate: 'cualquier fecha',
		topic: 'Topics',
		audience: 'Audiences',
		contenttype: 'Content Types',
		popularTerms: 'La gente también busca...',
		langen: 'Inglés',
		langes: 'Español',
		langfr: 'Francés',
		langde: 'Alemán',
		langzh: 'Chino',
		langko: 'Coreano',
		langvi: 'Vietnamita',
		langja: 'Japonés',
		langru: 'Ruso',
		langpt: 'Portugués',
		langit: 'Italiano',
		viewInPage: 'Ver en la página',
		dateRange: 'Rango de fechas',
		allDates: 'Todas las fechas',
		last7Days: 'Últimos 7 días',
		last30Days: 'Últimos 30 días',
		last60Days: 'Últimos 60 días',
		last90Days: 'Últimos 90 días',
		filterByDate: 'Filtrar por fecha',
	},
};

const getLanguage = (config, additionalDicts) => {
	dicts = utils.mergeDeep(dicts, additionalDicts);
	const dict = dicts[config.language] ? dicts[config.language] : dicts['en-us'];
	const lang = (term, args) => {
		var out = String(dict[term] || term).trim();
		var matches = out.match(/(\$\d+)/g);
		if (matches) {
			matches.forEach((match, i) => {
				var replace = String(Array.isArray(args) && i < args.length ? args[i] : '');
				out = out.replace(match, replace);
			});
		}
		out = out.replace(/\s\s+/g, ' ').trim();
		return out;
	};
	lang.lower = (term, args) => {
		return lang(term, args).toLowerCase();
	};
	lang.titleCase = (term, args) => {
		return utils.titleCase(lang(term, args));
	};
	lang.ucFirst = (term, args) => {
		return utils.ucFirst(lang(term, args).trim());
	};
	lang.lcFirst = (term, args) => {
		return utils.lcFirst(lang(term, args).trim());
	};
	lang.stripFiller = (sentence) => {
		sentence = utils.cleanString(sentence);
		fillerWords.forEach((filler) => {
			//.replace(/\b\s*the\b/g, '')
			sentence = sentence.replace(new RegExp('\\b\\s*' + filler + '\\b', 'g'), '');
		});
		return sentence.trim();
	};
	return lang;
};

export default getLanguage;
